import apiAuth from "./apiAuth";
import authHeader from "./auth-header";

const API_URL =
  process.env.NODE_ENV === "production"
    ? "https://robsdyno.malejkoit.com/api/v1.0.0/"
    : "http://localhost:8000/api/v1.0.0/";

class TechnicianService {
  getTechnicians() {
    return apiAuth.get(API_URL + "technicians/", { headers: authHeader() });
  }

  createTechnician(data) {
    return apiAuth.post(API_URL + "technicians/", data, { headers: authHeader() });
  }

  deleteTechnician(id) {
    return apiAuth.delete(API_URL + `technicians/${id}/`, { headers: authHeader() });
  }
}

export default new TechnicianService();
